import PropTypes from "prop-types"
import Error from "components/error"
import Loading from "components/loading"
import { ERROR, LOADING } from "helpers/data-statuses"
import { useModelBetaFields } from "resources/beta"
import { usePositionSetBetaInstrument } from "connected-components/asset-view/helpers"
import { combineTanStackStatuses } from "helpers/data-statuses"
import { useFactorsViewData } from "connected-components/factors-view/hooks/use-factors-view-data"
import FactorsViewBetaComponent from "./component"

export default function FactorsViewBeta({ instrumentsWithMetadata, ...props }) {
  const { modelId, endDate } = useFactorsViewData()

  const [modelBetaFields, modelBetaFieldsStatus] = useModelBetaFields(modelId)
  const betaInstrument = usePositionSetBetaInstrument(instrumentsWithMetadata.original, { id: modelId, date: endDate })

  const status = combineTanStackStatuses([modelBetaFieldsStatus])

  if (status === LOADING) {
    return <Loading />
  }
  if (status === ERROR) {
    return <Error />
  }

  return <FactorsViewBetaComponent betaInstrument={betaInstrument} betaFields={modelBetaFields} instrumentsWithMetadata={instrumentsWithMetadata} {...props} />
}

FactorsViewBeta.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  instrumentsWithMetadata: PropTypes.object.isRequired,
}
